// export const API = endpoint => "http://localhost:8000/v1/" + endpoint;
export const API = endpoint => "http://api-aval.sistemas.cetreina.uerj.br/v1/" + endpoint;

export const cabecalhoPadraoRequisicao = (flagDistribuicaoPorAvaliadorProjetos) => {
	if (flagDistribuicaoPorAvaliadorProjetos == true)
		return {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization:  `Bearer ${sessionStorage.getItem('AVAL_TOKEN')}`,
			'Ano-Base-Request': localStorage.getItem('AVAL_CONFIG_APP_ANOBASE'),
			'Distribuicao-Listagem-Projeto': 'SIM',
		}

	return {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		Authorization:  `Bearer ${sessionStorage.getItem('AVAL_TOKEN')}`,
		'Ano-Base-Request': localStorage.getItem('AVAL_CONFIG_APP_ANOBASE')
	}
}

export const formatarCPF = (cpf) => {
	// retira os caracteres indesejados...
	let conteudoCPF = cpf.replace(/[^\d]/g, "");

	// realizar a formatação...
	return conteudoCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export const esconderPartesCPF = (cpf) => cpf.replace(/\d(?<=\d{4})\d(?=\d{2})/g, "##");

export function gerarStringAleatoria(tamanho = 3) {
	// removido letras o O l i I e números 0 e 1 pra evitar confusão na hora de confirmar o captcha
	// let caracteres = "23456789abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ!#$%*";

	// removido caracteres pra deixar o catpcha mais fácil para digitar
	let caracteres = "23456789abcdefghjkpqrtwxy";
	let sa = '';

	for (let i = 0; i < tamanho; i++) {
		sa += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
	}
	
	// retorna o string aleatória gerada
	return sa;
}

export const verificarLocalStorage = (chave) => localStorage.getItem(chave) != null ? true : false;
export const verificarSessionStorage = (chave) => sessionStorage.getItem(chave) != null ? true : false;
export const verificarSeExisteCacheAvaliacoes = (pagina) => localStorage.getItem(`AVAL_LISTAGEM_AVALIACOES_CACHE_PG${pagina}`) != null ? true : false;
export const verificarSeExisteCacheProjetos = (pagina) =>localStorage.getItem(`AVAL_LISTAGEM_PROJETOS_CACHE_PG${pagina}`) != null ? true : false;
export const verificarSeExisteCacheUsuarios = (pagina) => localStorage.getItem(`AVAL_LISTAGEM_USUARIOS_CACHE_PG${pagina}`) != null ? true : false;

export const verificarSeExisteCacheChaveLS = (pagina, chaveLS) => localStorage.getItem(chaveLS + pagina) != null ? true : false;

export const StatusHttp = {
	OK: 200,
	CREATED: 201,
	HTTP_NO_CONTENT: 204,
	BAD_REQUEST: 400,
	UNAUTHORIZED: 401,
	HTTP_NOT_FOUND: 404,
	PRECONDITION_FAILED: 412,
	UNPROCESSABLE_ENTITY: 422,
	TOO_MANY_REQUESTS: 429
}

export const TipoEvento = {
	ESTA_CARREGANDO: 1,
	ABRIR_MODAL: 2,
	FECHAR_MODAL: 3,
}

export const TextoFeedback = {
	ERRO_REQUISICAO: "Erro na requisição, verifique a conexão com a rede ou configurações do navegador e tente novamente mais tarde."
}

export const TiposObjetosListagem = {
	USUARIO: 0,
	PROJETO: 1,
	PROJETO_ANON: 2,
	AVALIACAO: 3,
	AVALIACAO_ANON: 4,
	DISTRIBUICAO: 5,
	AFIRMACAO: 6,
	BOLSISTA: 7,
	APRESENTACAO_SEMGRAD: 8,
	APRESENTACAO_SEMGRAD_ANON: 9,
	GRUPO: 10,
}

export const TipoPerfil = {
	CETREINA: 'CETREINA',
	COORDENADOR: 'COORDENADOR',
	DISCENTE: 'DISCENTE',
	AVALIADOR: 'AVALIADOR'
}

export const ConteudoProjeto = {
	prodocencia: `
		<h2><span class="text-huge">FUNDAMENTAÇÃO TEÓRICA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">JUSTIFICATIVA DE IMPLEMENTAÇÃO DO PROJETO<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">OBJETIVOS<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">APRESENTAÇÃO DO CONTEXTO (Local em que será implementado o projeto) e do público alvo (que poderá ser impactado com o projeto)<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">ESTRATÉGIA METODOLÓGICA DO PROJETO DE TRABALHO (Desenho do projeto de trabalho e participantes envolvidos que atuarão diretamente no desenvolvimento do projeto)<span></h2>
		<p>[ PREENCHER ]</p>
		
		<br>
		<h2><span class="text-huge">ESTRATÉGIAS DE ACOMPANHAMENTO E MONITORAMENTO<span></h2>
		<p>[ PREENCHER ]</p>
		
		<br>
		<h2><span class="text-huge">EXPECTATIVA DO IMPACTO DO PROJETO DE TRABALHO<span></h2>
		<p>[ PREENCHER ]</p>
		
		<br>
		<h2><span class="text-huge">CRONOGRAMA DE EXECUÇÃO<span></h2>
		<p>[ PREENCHER ]</p>
	`,

	monitoria: `
		<h2><span class="text-huge">DISCIPLINA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">CARACTERIZAÇÃO DA DISCIPLINA (número de alunos, retenção e evasão, período no qual é oferecida, quais cursos atende)<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">JUSTIFICATIVA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">OBJETIVOS<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">ATIVIDADES DOS ORIENTADORES<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">ATIVIDADES E ACOMPANHAMENTO DOS MONITORES<span></h2>
		<p>[ PREENCHER ]</p>
		
		<br>
		<h2><span class="text-huge">RESULTADOS ESPERADOS<span></h2>
		<p>[ PREENCHER ]</p>
	`,

	eic_id: `
		<h2><span class="text-huge">JUSTIFICATIVA<span></h2>
		<p>[ PREENCHER ]</p>
		
		<br>
		<h2><span class="text-huge">FUNDAMENTAÇÃO TEÓRICO-METODOLÓGICA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">OBJETIVOS GERAIS<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">OBJETIVOS ESPECÍFICOS<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">PÚBLICO-ALVO<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">ATIVIDADES A SEREM DESENVOLVIDAS<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">CRONOGRAMA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">OBJETIVOS, ATIVIDADES E PROPOSTA DE AVALIAÇÃO DO(A) BOLSISTA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">GRADUAÇÃO DO(A) BOLSISTA<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">RESULTADOS ESPERADOS<span></h2>
		<p>[ PREENCHER ]</p>

		<br>
		<h2><span class="text-huge">BIBLIOGRAFIA<span></h2>
		<p>[ PREENCHER ]</p>
	`
}

export const ConteudoRelatorioProjeto = {
	coordenador_prodocencia: `
		<h2><span class="text-huge">ATIVIDADES PROPOSTAS AOS BOLSISTAS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">RESULTADOS OBTIDOS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">DIFICULDADES ENCONTRADAS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">AVALIAÇÃO DO TRABALHO DESENVOLVIDO<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">ATUAÇÃO DO(A) BOLSISTA (DETALHAR POR BOLSISTA)<span></h2>
		<p>[ PREENCHER ]</p>
		<br>
		
		<h2><span class="text-huge">PRÓXIMAS ETAPAS E PERSPECTIVAS DO PROJETO<span></h2>
		<p>[ PREENCHER ]</p>
		<br>
		
		<h2><span class="text-huge">DOCUMENTOS REFERENTES ÀS ALTERAÇÕES REALIZADAS DURANTE A EXECUÇÃO DO PROJETO<span></h2>
		<p>[ SUBIR ARQUIVOS PARA ALGUM SERVIÇO DE ARMAZENAMENTO ONLINE (Google Drive, OneDrive etc) E COLOCAR OS LINKS COMPARTILHADOS AQUI ]</p>
		<br>
		
		<h2><span class="text-huge">OBSERVAÇÕES<span></h2>
		<p>[ PREENCHER - opcional]</p>
		<br>
	`,

	bolsista_prodocencia: `
		<h2><span class="text-huge">AVALIAÇÃO DO TRABALHO DESENVOLVIDO NO PROJETO<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">AVALIAÇÃO DA SUA ATUAÇÃO COMO BOLSISTA<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">AVALIAÇÃO DA ATUAÇÃO DO COORDENADOR<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">DIFICULDADES ENCONTRADAS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">SUGESTÕES E OBSERVAÇÕES<span></h2>
		<p>[ PREENCHER ]</p>
		<br>
	`,

	coordenador_monitoria: `
		<h2><span class="text-huge">PLANO DE ATIVIDADES DO MONITOR: Todas as atividades planejadas foram cumpridas? Em caso negativo, qual a razão?<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">RETENÇÃO: A disciplina apresenta problemas de retenção?<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">RETENÇÃO: Existindo problemas de retenção, que procedimentos foram adotados para reverter estes índices?<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">AVALIAÇÃO DOS BOLSISTAS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">AVALIAÇÃO DOS RESULTADOS OBTIDOS: (Dificuldades encontradas, perspectivas de diminuição dos índices de retenção e/ou evasão, etc.)<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">JUSTIFICATIVA PARA SOLICITAÇÃO DA MONITORIA PARA O PRÓXIMO ANO<span></h2>
		<p>[ PREENCHER ]</p>
		<br>
	`,

	coordenador_eic_id: `
		<h2><span class="text-huge">RESUMO DO PROJETO<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">ATIVIDADES PROPOSTAS AO BOLSISTA<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">RESULTADOS OBTIDOS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">DIFICULDADES ENCONTRADAS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">AVALIAÇÃO DO TRABALHO DESENVOLVIDO<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">ATUAÇÃO DO(A) BOLSISTA<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">PERSPECTIVA<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">OBSERVAÇÕES<span></h2>
		<p>[ PREENCHER - opcional]</p>
		<br>
	`,
	
	discente_mon_eic_id: `
		<h2><span class="text-huge">RELACIONE AS ATIVIDADES REALIZADAS POR VOCÊ<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">QUE CONTRIBUIÇÕES PARA SUA FORMAÇÃO PROFISSIONAL ESTA EXPERIÊNCIA LHE TROUXE<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">QUAIS AS DIFICULDADES ENCONTRADAS<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">COMENTE A ATUAÇÃO DO SEU SUPERVISOR/ORIENTADOR COM BASE NOS ITENS: frequência, relacionamento pessoal e profissional, apoio a execução das atividades e acrescente outros caso considere necessário<span></h2>
		<p>[ PREENCHER ]</p>
		<br>

		<h2><span class="text-huge">OBSERVAÇÕES<span></h2>
		<p>[ PREENCHER - opcional]</p>
		<br>
	`
}

export const dadosUsuarioLS = () => {
	return JSON.parse(localStorage.getItem('AVAL_USUARIO_DADOS'));
}

export function parseJWT(token) {
	try {
		return JSON.parse(window.atob(token.split('.')[1]));
	} catch (e) {
		return null;
	}
}

/**
 * algumas chaves não serão removidas pois são dados estáticos 
 * do sistema (pouca mudança na API) ou são de personalização do usuário (tema etc)
 * @return void
 */
export const limparLocalStorage = (limparToken, limparDadosUsuario, limparCacheUsuarios, limparCacheProjetos) => {
	if (limparToken === true)
		sessionStorage.removeItem('AVAL_TOKEN');
	
	if (limparDadosUsuario === true)
		localStorage.removeItem('AVAL_USUARIO_DADOS');

	// limpa cache dos usuarios
	if (limparCacheUsuarios === true) {
		Object.keys(localStorage)
			.filter( nomeChave => nomeChave.includes('AVAL_LISTAGEM_USUARIOS_CACHE_PG'))
			.forEach(item => localStorage.removeItem(item));
	}

	// limpa cache dos projetos
	if (limparCacheProjetos === true) {
		Object.keys(localStorage)
			.filter( nomeChave => nomeChave.includes('AVAL_LISTAGEM_PROJETOS_CACHE_PG'))
			.forEach(item => localStorage.removeItem(item));
	}
}

export function convertHMS(value) {
	const sec = parseInt(value, 10); // convert value to number if it's string
	
	let hours   = Math.floor(sec / 3600); // get hours
	let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
	let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
	
	// add 0 if value < 10; Example: 2 => 02
	if (hours   < 10) {hours   = "0"+hours;}
	if (minutes < 10) {minutes = "0"+minutes;}
	if (seconds < 10) {seconds = "0"+seconds;}
	
	return hours+':'+minutes+':'+seconds; // Return is HH : MM : SS
}

export function limparCacheTotal() {
	Object.keys(localStorage)
		.filter(nomeChave => nomeChave.includes('AVAL_'))
		.forEach(item => localStorage.removeItem(item));

	// remove token da session storage
	sessionStorage.removeItem('AVAL_TOKEN');
}

/**
 * pontuação máximoa = 5  - cinco (valores inferiores: 4,393 - quatro virgula trezentos e noventa e 
 * três ... 0,234 ... etc, por padrão a API devolve valor com casas decimais separado por ponto, 
 * podendo dar leitura errada de 4.234 - quatro mil duzentos e trinta e quatro)
 */
export const ajustarExibicaoPontuacao = (valor) => {
	return valor.toFixed(3).toString().replace(".", ",");
}

export function converterJSONParaCSV(dadosJSON, nomeArquivo, exibirCabecalhoColunas) {
	// se dadosJSON não é um objeto então a função JSON.parse fará o parsing da string/JSON em um Object
	let dadosArray = typeof dadosJSON != 'object' ? JSON.parse(dadosJSON) : dadosJSON;

	let CSV = 'sep=,' + '\r\n\n';

	if (exibirCabecalhoColunas) {
		let linha = "";

		//This loop will extract the label from 1st i of on array
		for (let i in dadosArray[0]) {

			//Now convert each value to string and comma-seprated
			linha += i + ',';
		}

		linha = linha.slice(0, -1);

		//append Label linha with line break
		CSV += linha + '\r\n';
	}

	// primeiro loop vai exrtrair cada linha
	for (let i = 0; i < dadosArray.length; i++) {
		let linha = "";

		// segundo loop irá extrair cada coluna e converte-la em uma string separada por virgula
		for (let j in dadosArray[i]) {
			linha += '"' + dadosArray[i][j] + '",';
		}

		linha.slice(0, linha.length - 1);

		// adiciona uma quebra de linha após cada linha
		CSV += linha + '\r\n';
	}

	if (CSV == '') {
		alert("Tabela/listagem possui dados inválidos. Operação cancelada.");
		return;
	}

	let prefixoNomeArquivo = "AVAL_";

	// remove os espaços em branco do nome do arquivo informado no parametro e coloca underscores no lugar
	prefixoNomeArquivo += nomeArquivo.replace(/ /g, "_");

	// inicializa o formatado do arquivo desajado (csv ou xls)
	let uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

	// Now the little tricky part.
	// you can use either>> window.open(uri);
	// but this will not work in some browsers
	// or you will not get the correct file extension    

	//this trick will generate a temp <a /> tag
	let link = document.createElement("a");
	link.href = uri;

	//set the visibility hidden so it will not effect on your web-layout
	link.style = "visibility:hidden";
	link.download = prefixoNomeArquivo + ".csv";

	//this part will append the anchor tag and remove it after automatic click
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export const revstr = (str) => str.split("").reverse().join("");
export const gerarNrEntre = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

// só funciona localmente ou servidor com protocolo HTTPS
export const copiarParaAreaTransferencia = (elemento) => {
	/* Get the text field */
	// var copyText = document.getElementById("myInput");

	/* Select the text field */
	// elemento.select();
	// elemento.setSelectionRange(0, 99999); /* For mobile devices */

	/* Copy the text inside the text field */
	navigator.clipboard.writeText(elemento.outerText);

	/* Alert the copied text */
	alert("Texto copiado para a área de transferência.");
}

// retorna true se operação foi realizada com sucesso, false caso contrário
export const enviarDadosFormulario = async (
	metodo,
	dispatchCallback, 
	replaceCallback, 
	endpoint, 
	corpoRequisicao, 
	mensagemSucesso,
	rotaReplaceSucesso,
	rotaReplaceFalha) => {
	
	let tituloAviso = "Erro...";
	let feedbackUsuario = [];
	let retornoSucesso = true;

	dispatchCallback('routeEvent', {
		tipo: TipoEvento.ESTA_CARREGANDO,
		valor: true,
		mensagem: 'Enviando os dados ...',
	});
		
	// faz a chamada a API no endpoint informado, envia os dados e aguarda a resposta
	const resposta = await fetch(API(endpoint), {
		method: metodo,
		headers: cabecalhoPadraoRequisicao(),
		body: corpoRequisicao
	}).catch(erros => {
		console.error(erros);
		
		dispatchCallback('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'Erro na requisição',
			conteudo: TextoFeedback.ERRO_REQUISICAO
		});

		retornoSucesso = false;
	});

	// pega o json do retorno da resposta
	const json = await resposta.json();

	if (resposta.status == StatusHttp.CREATED | resposta.status == StatusHttp.OK) {
		tituloAviso = 'Operação realizada com sucesso!'
		feedbackUsuario.push(mensagemSucesso);
		replaceCallback(rotaReplaceSucesso);
	} else if (resposta.status == StatusHttp.UNPROCESSABLE_ENTITY) {
		tituloAviso = 'Verifique os dados informados!'
		feedbackUsuario.push(json?.mensagem);
	} else {
		feedbackUsuario.push(json?.mensagem);
		replaceCallback(rotaReplaceFalha);
		retornoSucesso = false;
	};

	dispatchCallback('routeEvent', { 
		tipo: TipoEvento.ESTA_CARREGANDO,
		valor: false
	});

	// exibe feedback pro usuário se existir algo pra exibir
	if (feedbackUsuario[0]) {
		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: tituloAviso,
			conteudo: feedbackUsuario[0]
		});
	}

	// limpa as mensagens
	feedbackUsuario = [];

	return retornoSucesso;
}

// export atualizarValorLS = (nomeLS, objeto) => {
	// localStorage.setItem(nomeLS, JSON.stringify(yourObject));
// var item = JSON.parse(localStorage.getItem('itemKey'));
// }

export const listarObjetosAPI = async (
	endpoint,
	dispatchCallback, 
	replaceCallback,
	rotaReplaceFalha) => {

	let objetoRetorno = {};

	dispatchCallback('routeEvent', {
		tipo: TipoEvento.ESTA_CARREGANDO,
		valor: true,
		mensagem: 'Carregando dados ...',
	});

	const resposta = await fetch(API(endpoint), {
		method: 'GET',
		headers: cabecalhoPadraoRequisicao(),
	}).catch(erros => {
		console.log(erros);

		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'Erro',
			conteudo: TextoFeedback.ERRO_REQUISICAO
		});

		replaceCallback("/");
	});
	
	const json = await resposta.json();

	if (resposta.status == StatusHttp.OK) {
		let { dados: { data, meta } } = json;

		objetoRetorno = {
			dados: data,
			paginacao: {
				paginaAtual: meta.current_page,
				paginaAnterior: meta.current_page - 1,
				proximaPagina: meta.current_page + 1,
				totalResultados: meta.total,
				ultimaPagina: meta.last_page,
				resultadosPorPagina: meta.per_page
			}
		};
	} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'Aviso!',
			conteudo: 'Nenhum registro encontrado.'
		});

		replaceCallback("/painel");
	} else {
		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'Aviso',
			conteudo: json?.mensagem
		});
		
		replaceCallback(rotaReplaceFalha);
	}

	dispatchCallback('routeEvent', { 
		tipo: TipoEvento.ESTA_CARREGANDO,
		valor: false
	});

	return objetoRetorno;
}

export const carregarEditorTexto = (nomeClasseElementoContainer, conteudoHtml, atualizacao = false, callbackFlagEditorCarregado) => {
	ClassicEditor.create(document.querySelector(`.${nomeClasseElementoContainer}`), {
		toolbar: {
			viewportTopOffset: 1,
			shouldNotGroupWhenFull: true
		},
		language: 'pt-br',
		licenseKey: '',
	}).then( editor => {
		window.editor = editor;
		
		if (atualizacao)
			editor.setData('Carregando conteúdo...');
		else
			editor.setData(conteudoHtml);
	}).catch( erro => {
		console.error('Erro ao carregar editor');
		console.error('Por favor reporte ao suporte.');
		console.error(erro);
	}).finally( () => {
		if (atualizacao)
			setTimeout( () => editor.setData(conteudoHtml), 1000);
		
		callbackFlagEditorCarregado(true);
	});
}

export const usuarioListagemDTO = (usuario) => {
	return {
		tag: usuario.perfis,
		link: `#/usuario/visualizar/${usuario.cpf}`,
		titulo: usuario.nome,
		descricao: `Unidade: ${usuario.unidade} - CPF: ${usuario.cpf}`
	}
}

export const bolsistaListagemDTO = (bolsista) => {
	console.log(bolsista);
	return {
		tag: `Cód.: ${bolsista.projeto_codigo}`,
		titulo: bolsista.nome,
		descricao: `
			<p>Projeto: <strong>${bolsista.projeto_titulo}</strong></p>
			<p>Indicação realizada em ${bolsista.data_indicacao}</p>
			<p>Matrícula do(a) bolsista: ${bolsista.matricula}</p>
			<div class="notification is-info is-light">
			Curso do(a) bolsista: ${bolsista.curso}
			<br>
			Recondução: <strong>${bolsista.reconducao}</strong>
			<br>
			<p>Anexos: ${bolsista.anexos.map(a => Object.values(a).join(": ")).join(" | ")}</p>
			</div>
			
		`,
		acoes: [{
			url: `#/usuario/visualizar/${bolsista.cpf}`,
			texto: 'Ver cadastro do(a) bolsista'
		}, {
			url: `#/projeto/visualizar/${bolsista.projeto_codigo}`,
			texto: 'Ver projeto'
		}],
	}
}

export const projetoListagemDTO = (projeto) => {
	return {
		tag: projeto.modalidade,
		link: `#/projeto/visualizar/${projeto.codigo}`,
		titulo: projeto.titulo,
		descricao: `Alocação: ${projeto.alocacao} \n Unidade ${projeto.unidade}`
	}
}

export const apresentacaoSemanaGraduacaoListagemDTO = (apresentacao) => {
	return {
		tag: 'Inscrição:' + apresentacao.inscricao,
		link: `#/apresentacao/visualizar/${apresentacao.id}/${apresentacao.projeto.codigo}`,
		titulo: apresentacao.projeto.titulo
	}
}

// export const avaliacaoListagemDTO = (avaliacao) => {
// 	return {
// 		tag: avaliacao.finalizada == true ? 'FINALIZADA' : 'PENDENTE',
// 		link: `#/avaliacao/visualizar/${avaliacao.id}`,
// 		titulo: `Proj.: ${avaliacao.projeto.titulo}`,
// 		descricao: `Avaliado por: ${avaliacao.avaliador.nome} # em ${avaliacao.data_ultima_atualizacao}`
// 	}
// }

export const afirmacaoListagemDTO = (afirmacao) => {
	return {
		tag: afirmacao.formularios,
		acoes: [{
			url: afirmacao.ativa == true 
				? `#/banco-afirmacoes/ativar-desativar/${afirmacao.id}/${window.btoa('DESATIVAR')}` 
				: `#/banco-afirmacoes/ativar-desativar/${afirmacao.id}/${window.btoa('ATIVAR')}`,
			texto: afirmacao.ativa == true ? 'Desativar' : 'Ativar'
		}],
		titulo: afirmacao.titulo,
		descricao: `Cadastrada em ${afirmacao.data_criacao} | Intenção: ${afirmacao.intencao} | Ativa: ${afirmacao.ativa == true ? 'SIM' : 'NÃO'}`
	}
}

export const avaliacaoObjetoListagemDTO = (avaliacao) => {
	return {
		tag: avaliacao.finalizada == true ? 'FINALIZADA' : 'PENDENTE',
		link: `#/avaliacao/visualizar/${avaliacao.id}`,
		titulo: avaliacao.objetoAvaliado.titulo ?? avaliacao.objetoAvaliado.projeto.titulo,
		descricao: `${avaliacao.objetoAvaliadoEProjeto == true ? '[PROJETO]' : '[APRESENTAÇÃO]'}` + ` - Avaliado por: ${avaliacao.avaliador.nome} # em ${avaliacao.data_ultima_atualizacao}`
	}
}

export const grupoListagemDTO = (grupo) => {
	return {
		tag: grupo.tipo,
		link: `#/grupos/visualizar/${grupo.id}`,
		titulo: grupo.nome,
		descricao: grupo.descricao_resumo
	}
}

// para avaliadores
export const avaliacaoObjetoListagemAnonimizadaDTO = (avaliacao) => {
	// let curriculo = {
	// 	tag: avaliacao.finalizada == true ? 'FINALIZADA' : 'PENDENTE',
	// 	// link: avaliacao.finalizada 
	// 	// 	? montarURN('avaliacao/visualizar', gerarQueryString({ idAvaliacao: avaliacao.id }))
	// 	// 	: montarURN('curriculo/visualizar/anonimizado', gerarQueryString({ codigoCurriculo: avaliacao.objetoAvaliado.codigo, idAvaliacao: avaliacao.id })),
	// 	link: "#",
	// 	titulo: `Currículo: ${avaliacao.objetoAvaliado.codigo}`,
	// 	descricao: `Avaliador: ${avaliacao.avaliador.nome} # em ${avaliacao.data_ultima_atualizacao}`
	// };
	
	// let projeto = {
	// 	tag: avaliacao.finalizada == true ? 'FINALIZADA' : 'PENDENTE',
	// 	// link: avaliacao.finalizada 
	// 	// 	? montarURN('avaliacao/visualizar', gerarQueryString({ idAvaliacao: avaliacao.id }))
	// 	// 	: montarURN('projeto/visualizar/anonimizado', gerarQueryString({ codigoProjeto: avaliacao.objetoAvaliado.codigo, idAvaliacao: avaliacao.id })),
	// 	link: "#",
	// 	titulo: `Projeto: ${avaliacao.objetoAvaliado.titulo}`,
	// 	descricao: `Avaliador: ${avaliacao.avaliador.nome} # em ${avaliacao.data_ultima_atualizacao}`
	// };

	// return avaliacao.objetoAvaliado.hasOwnProperty('titulo') ? projeto : curriculo;
}

export const ativarLinksEmTexto = (texto) => {
	if(!texto) return;

	var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
	
	return texto.replace(urlRegex, function (url) {
		var hyperlink = url;
		
		if (!hyperlink.match('^https?:\/\/')) {
			hyperlink = 'http://' + hyperlink;
		}

		return '<a href="' + hyperlink + '" target="_blank">' + url + '</a>'
	});
}

export const rolarPagina = (valorPixelsY) => window.scrollTo(0, valorPixelsY);
export const codificarTituloProjeto = (titulo) => window.btoa(unescape(encodeURIComponent(titulo)));
export const decodificarTituloProjeto = (tituloCodificado) => decodeURIComponent(escape(window.atob(tituloCodificado)));

export const codificarPayloadURL = (payload) => window.btoa(unescape(encodeURIComponent(payload)));
export const decodificarPayloadURL = (payloadCodificado) => decodeURIComponent(escape(window.atob(payloadCodificado)));

export const removerObjeto = async (idObjeto, dispatchCallback, replaceOuPushCallback, rotaReplaceSucesso, endpoint, mensagemAlerta = "Deseja realmente remover esta informação?") => {
	let confirmacaoUsuario = window.confirm(mensagemAlerta);

	if (confirmacaoUsuario) {
		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Removendo ...',
		});

		const resposta = await fetch(API(endpoint), {
			method: 'DELETE',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				id: idObjeto
			})
		}).catch(erro => { throw new Error(`[${ erro.message }] - ${ TextoFeedback.ERRO_REQUISICAO }`) });

		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			dispatchCallback('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Tudo certo!',
				conteudo: 'Informação removida.'
			});

			replaceOuPushCallback(rotaReplaceSucesso);
		} else throw new Error(json.mensagem ?? 'Não foi possível processar esta requisição.');

		dispatchCallback('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
}